export default __webpack_public_path__ + "static/media/Hotel-Poinisuk-shillong.b4a4ef08.jpg";